import { FC, ReactNode } from "react";
import "./DangerZoneCard.css";

const cardStyle = {
  backgroundColor: "#efeff4",
  border: "3px solid red",
  color: "red",
  marginTop: "40px",
  marginBottom: "40px",
};

const DangerZoneCard: FC<{
  children: ReactNode;
  header: ReactNode;
  footer?: ReactNode;
}> = ({ header, children, footer }) => (
  <div className="card card-danger" style={cardStyle}>
    <div className="card-header">{header}</div>
    <div className="card-content">{children}</div>
    {footer ? <div className="card-footer">{footer}</div> : null}
  </div>
);

export default DangerZoneCard;
